import { useState } from 'react';
import Login from '../components/login/Login';
import TopBar from '../components/login/TopBar';

const Auth = () => {
  // const [signUp, toggleSignUp] = useState(false);

  return (
    <>
      <TopBar />
      <Login />
    </>
  );
  // return <>{signUp ? <></> : <Login />}</>;
};

export default Auth;
